export default "__VITE_ASSET__Db52LZmf__"